const Layout = () => import('@/layouts/index.vue');
const routes = {
    path: '/user/feedback',
    component: Layout,
    name: 'AppUserFeedback',
    meta: {
        title: '用户反馈',
        icon: 'carbon:user-feedback',
    },
    children: [
        {
            path: '',
            name: 'AppUserFeedbackList',
            component: () => import('@/views/app/user_feedback/list.vue'),
            meta: {
                title: '用户反馈',
                activeMenu: '/user/feedback',
            },
        },
        {
            path: 'category',
            name: 'AppUserFeedbackCategoryList',
            component: () => import('@/views/app/user_feedback/category/list.vue'),
            meta: {
                title: '反馈类别',
            },
        },
        {
            path: 'type',
            name: 'AppUserFeedbackTypeList',
            component: () => import('@/views/app/user_feedback/fb_type/list.vue'),
            meta: {
                title: '反馈类型',
            },
        },
    ],
};
export default routes;
